// extracted by mini-css-extract-plugin
var _1 = "768px";
var _2 = "Question_questionContainer__R42il";
var _3 = "Question_questionDisclaimer__HJD8o";
var _4 = "Question_questionLabel__50c3i";
var _5 = "Question_questionLabelContainer__OZNt9";
var _6 = "Question_questionSubLabel__pCXR4";
var _7 = "Question_radioColorQuestion__KBhgg";
var _8 = "\"../../../shared.module.css\"";
export { _1 as "md", _2 as "questionContainer", _3 as "questionDisclaimer", _4 as "questionLabel", _5 as "questionLabelContainer", _6 as "questionSubLabel", _7 as "radioColorQuestion", _8 as "shared" }
